import React from 'react';

import {sx} from './sx'
import Box from '@mui/material/Box';
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    color?: string,
    active?: boolean,
    sx?: SxType,
}

const EmptyLineSingleVoyage = ({
                       color = '#d9d8d8',
                       active,
                       sx: sxProps={}
                   }: IProps) => {
    return (
        <Box sx={{
            ...sx.root,
            borderRight: `2px ${active ? 'solid' : 'dashed'} ${color}`,
            ...sxProps,
        }}/>

    );
};

export default EmptyLineSingleVoyage;